package ru.arty_bikini.crm_frontend.table.report

import ru.arty_bikini.crm.dto.enums.UserGroup
import ru.arty_bikini.crm.dto.enums.personalData.ClientType
import ru.arty_bikini.crm.dto.filter.OrderFilter
import ru.arty_bikini.crm.dto.orders.OrderDTO
import ru.arty_bikini.crm.dto.orders.PersonalDataDTO
import ru.arty_bikini.crm_frontend.form.main.ArchiveMainForm
import ru.arty_bikini.crm_frontend.table.common.commonPage
import ru.arty_bikini.crm_frontend.ui.bootstrap.BootstrapColor
import ru.arty_bikini.crm_frontend.ui.bootstrap.alert
import ru.arty_bikini.crm_frontend.ui.bootstrap.cardLightShadow
import ru.arty_bikini.crm_frontend.ui.input.table.*
import ru.arty_bikini.crm_frontend.ui.input.table.data.DataSourceLoadingState
import ru.arty_bikini.crm_frontend.ui.input.table.data.month.MonthPagerDataProviderOrder
import ru.arty_bikini.crm_frontend.ui.input.types.or

val ConversionTablePage = commonPage(
    requireGroups = listOf(UserGroup.ADMIN, UserGroup.TANYA)
) { props ->


    MonthPagerDataProviderOrder(
        client = props.client,
        defaultFilter = ::OrderFilter
    ) { data ->

        cardLightShadow {
            if (data.state != DataSourceLoadingState.LOADED) {
                alert(BootstrapColor.WARNING) { +"Идет загрузка данных" }
            }

            if (data.state == DataSourceLoadingState.LOADED) {

                ConversionReport {
                    this.client = props.client
                    this.data = data.currentData
                }

            }

        }

        cardLightShadow {
            TablePanelOrderSource(props.client, data, "t-r-conversion") {
                addText(FieldFlag.ReadOnlyProp, "ФИО", OrderDTO::name, TableColumnRenderOptions(editButtonForm = ArchiveMainForm))
                addBoolean(FieldFlag.ReadOnlyProp, "Архив", OrderDTO::archive)
                addSelect(FieldFlag.ReadOnlyProp, "Тип", ClientType.values(), OrderDTO::type)
                addDateTime(FieldFlag.ReadOnlyProp, "Дата появления лида", OrderDTO::personalData or ::PersonalDataDTO then PersonalDataDTO::createdTime)
                addDateTime(FieldFlag.ReadOnlyProp, "Дата предоплаты", OrderDTO::personalData or ::PersonalDataDTO then PersonalDataDTO::orderTime)
                addDateTime(FieldFlag.ReadOnlyProp, "Дата попадания в архив", OrderDTO::personalData or ::PersonalDataDTO then PersonalDataDTO::archiveTime)
            }
        }
    }
}